<template>
  <v-tooltip
    top
    dark
  >
    <template v-slot:activator="{ on }">
      <v-chip
        class="account-chip"
        color="primary"
        text-color="white"
        selected
        @click="onClick"
        v-on="on"
      >
        <v-avatar>
          <v-icon>account_circle</v-icon>
        </v-avatar>
        <span>
          <b>{{ snr }}</b>

        </span>
      </v-chip>
    </template>
    Open account details page
  </v-tooltip>
</template>

<script>
export default {
  name: 'AccountChip',
  props: {
    snr: {
      type: String,
      default: null,
      required: true,
    },
  },
  methods: {
    onClick() {
      this.$router.push(`/baader/accounts/${this.snr}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.account-chip {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/baader/shared/AccountChip.vue